import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import * as Sentry from '@sentry/react';
import './index.css';
import App from './App.tsx';

const environment = import.meta.env.MODE;

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment,
  enabled: environment !== 'development',
  tracesSampleRate: environment === 'development' ? 0 : 1.0,
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
